<template>
  <div>
    <TransitionRoot as="template" :show="sidebarOpen">
      <Dialog as="div" class="fixed inset-0 flex z-40 md:hidden" @close="sidebarOpen = false">
        <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0"
          enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100"
          leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-600 bg-opacity-75" />
        </TransitionChild>
        <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
          enter-from="-translate-x-full" enter-to="translate-x-0" leave="transition ease-in-out duration-300 transform"
          leave-from="translate-x-0" leave-to="-translate-x-full">
          <div class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-gray-800">
            <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0"
              enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100" leave-to="opacity-0">
              <div class="absolute top-0 right-0 -mr-12 pt-2">
                <button type="button"
                  class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                  @click="sidebarOpen = false">
                  <span class="sr-only">Close sidebar</span>
                  <XIcon class="h-6 w-6 text-white" />
                </button>
              </div>
            </TransitionChild>
            <div class="flex-shrink-0 flex items-center px-4">
              <img class="h-8 w-auto" src="../assets/images/logo.png" alt="Logo Bizinix CRM" />
            </div>
            <div class="mt-5 flex-1 h-0 overflow-y-auto">
              <nav class="px-2 space-y-1">
                <template v-for="item in navigation" :key="item.name">
                  <template v-if="item.children">
                    <div class="pt-1">
                      <div class="flex items-center px-2 py-2 text-base font-medium text-gray-400">
                        <component :is="item.icon" class="mr-4 flex-shrink-0 h-6 w-6 text-gray-400" aria-hidden="true" />
                        {{ item.name }}
                      </div>
                      <router-link v-for="child in item.children" :key="child.name" :to="child.to"
                        active-class="bg-gray-900 text-white" :class="[
                          $router.currentRoute.value.name === child.to.name
                            ? ''
                            : 'text-gray-300 bg-inherit hover:bg-gray-700 hover:text-white',
                          'ml-4 group flex items-center px-2 py-2 text-base font-medium rounded-md'
                        ]">
                        <component :is="child.icon" :class="[
                          $router.currentRoute.value.name === child.to.name ? '' : 'text-gray-400 group-hover:text-gray-300',
                          'mr-4 flex-shrink-0 h-5 w-5'
                        ]" aria-hidden="true" />
                        {{ child.name }}
                      </router-link>
                    </div>
                  </template>
                  <template v-else>
                    <router-link :to="item.to" active-class="bg-gray-900 text-white" :class="[
                      $router.currentRoute.value.name === item.to.name
                        ? ''
                        : 'text-gray-300 bg-inherit hover:bg-gray-700 hover:text-white',
                      'group flex items-center px-2 py-2 text-base font-medium rounded-md',
                      item.name === 'Kategórie cien' || item.name === 'Kategórie článkov' || item.name === 'Správa kategórií predmetov podnikania' ? 'ml-4' : ''
                    ]">
                      <component :is="item.icon" aria-activedescendant="text-gray-300" :class="[
                        $router.currentRoute.value.name === item.to.name ? '' : 'text-gray-400 group-hover:text-gray-300',
                        'mr-4 flex-shrink-0 h-6 w-6',
                      ]" aria-hidden="true" />
                      {{ item.name }}
                    </router-link>
                  </template>
                </template>
              </nav>
            </div>
          </div>
        </TransitionChild>
        <div class="flex-shrink-0 w-14" aria-hidden="true">
          <!-- Dummy element to force sidebar to shrink to fit close icon -->
        </div>
      </Dialog>
    </TransitionRoot>

    <!-- Static sidebar for desktop -->
    <div class="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div class="flex-1 flex flex-col min-h-0 bg-gray-800">
        <div class="flex items-center h-16 flex-shrink-0 px-4 bg-gray-900">
          <img class="h-auto w-32" src="../assets/images/logo.png" alt="Logo Bizinix CRM" />
        </div>
        <div class="flex-1 flex flex-col overflow-y-auto">
          <nav class="flex-1 px-2 py-4 space-y-1">
            <template v-for="item in navigation" :key="item.name">
              <template v-if="item.children">
                <div class="pt-1">
                  <div class="flex items-center px-2 py-2 text-sm font-medium text-gray-400">
                    <component :is="item.icon" class="mr-3 flex-shrink-0 h-6 w-6 text-gray-400" aria-hidden="true" />
                    {{ item.name }}
                  </div>
                  <router-link v-for="child in item.children" :key="child.name" :to="child.to"
                    active-class="bg-gray-900 text-white" :class="[
                      $router.currentRoute.value.name === child.to.name
                        ? ''
                        : 'text-gray-300 bg-inherit hover:bg-gray-700 hover:text-white',
                      'ml-4 group flex items-center px-2 py-2 text-sm font-medium rounded-md'
                    ]">
                    <component :is="child.icon" :class="[
                      $router.currentRoute.value.name === child.to.name ? '' : 'text-gray-400 group-hover:text-gray-300',
                      'mr-3 flex-shrink-0 h-5 w-5'
                    ]" aria-hidden="true" />
                    {{ child.name }}
                  </router-link>
                </div>
              </template>
              <template v-else>
                <router-link :to="item.to" active-class="bg-gray-900 text-white" :class="[
                  $router.currentRoute.value.name === item.to.name
                    ? ''
                    : 'text-gray-300 bg-inherit hover:bg-gray-700 hover:text-white',
                  'group flex items-center px-2 py-2 text-sm font-medium rounded-md',
                  item.name === 'Kategórie cien' || item.name === 'Kategórie článkov' || item.name === 'Správa kategórií predmetov podnikania' ? 'ml-4' : ''
                ]">
                  <component :is="item.icon" active-class="text-gray-300" :class="[
                    $router.currentRoute.value.name === item.to.name ? '' : 'text-gray-400 group-hover:text-gray-300',
                    'mr-3 flex-shrink-0 h-6 w-6',
                  ]" aria-hidden="true" />
                  {{ item.name }}
                </router-link>
              </template>
            </template>
          </nav>
        </div>
      </div>
    </div>
    <div class="md:pl-64 flex flex-col">
      <div class="sticky top-0 z-10 flex-shrink-0 flex h-16 bg-white shadow">
        <button type="button"
          class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-teal-500 md:hidden"
          @click="sidebarOpen = true">
          <span class="sr-only">Open sidebar</span>
          <MenuAlt2Icon class="h-6 w-6" />
        </button>
        <div class="flex-1 px-4 flex justify-end">
          <div class="ml-4 flex items-center md:ml-6">
            <!-- Profile dropdown -->
            <Menu as="div" class="ml-3 relative">
              <div>
                <MenuButton
                  class="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                  <span class="sr-only">Open user menu</span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                  </svg>
                </MenuButton>
              </div>
              <transition enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95">
                <MenuItems
                  class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <MenuItem v-for="item in userNavigation" :key="item.name" v-slot="{ active }">
                  <a :href="item.href"
                    :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">{{
                      item.name }}</a>
                  </MenuItem>
                  <MenuItem v-slot="{ active }">
                  <button type="button" @click="logout()"
                    :class="[active ? 'bg-gray-100' : '', 'w-full flex justify-left px-4 py-2 text-sm text-gray-700']">
                    Odhlásiť sa
                  </button>
                  </MenuItem>
                </MenuItems>
              </transition>
            </Menu>
          </div>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import store from '@/store'
import { useRouter } from 'vue-router'
import {
  Dialog,
  DialogOverlay,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'
import {
  FolderIcon,
  HomeIcon,
  MenuAlt2Icon,
  UsersIcon,
  XIcon,
  ShoppingBagIcon,
  CubeIcon,
  NewspaperIcon,
  QuestionMarkCircleIcon,
  CurrencyDollarIcon,
  TagIcon,
  CollectionIcon,
  ChartBarIcon,
  LibraryIcon,
  DocumentDuplicateIcon,
  CogIcon
} from '@heroicons/vue/outline'

const navigation = [
   { name: 'Dashboard', to: { name: 'Dashboard' }, icon: HomeIcon },
   {
     name: 'Analytika',
     icon: ChartBarIcon,
     children: [
       { name: 'Generované doklady', to: { name: 'Analytika' }, icon: DocumentDuplicateIcon },
       { name: 'Prehľad obratu', to: { name: 'Obrat z objednávok' }, icon: CurrencyDollarIcon },
     ],
   },
   { name: 'Spoločnosti', to: { name: 'Úprava spoločností' }, icon: FolderIcon },
   { name: 'Klienti', to: { name: 'Úprava klientov' }, icon: UsersIcon },
   { name: 'Zásielky', to: { name: 'Zoznam zásielok' }, icon: CubeIcon },
   { name: 'Virtuálne sídla', to: { name: 'VHQ Zoznam' }, icon: LibraryIcon },
   { name: 'VHQ Management', to: { name: 'VHQ Management' }, icon: CogIcon },
   { name: 'Objednávky', to: { name: 'Zoznam objednávok' }, icon: ShoppingBagIcon },
   { name: 'Články', to: { name: 'Zoznam článkov' }, icon: NewspaperIcon },
   { name: 'Kategórie článkov', to: { name: 'Správa kategórií článkov' }, icon: CollectionIcon },
   { name: 'FAQ', to: { name: 'Zoznam FAQ' }, icon: QuestionMarkCircleIcon },
   { name: 'Správa cien', to: { name: 'Správa cien' }, icon: CurrencyDollarIcon },
   { name: 'Kategórie cien', to: { name: 'Správa kategórií cien' }, icon: TagIcon },
   { name: 'Správa predmetov podnikania', to: { name: 'Správa predmetov podnikania' }, icon: TagIcon },
   { name: 'Správa kategórií predmetov podnikania', to: { name: 'Správa kategórií predmetov podnikania' }, icon: CollectionIcon },
   { name: 'Správa stránok', to: { name: 'Správa stránok' }, icon: CollectionIcon },
   { name: 'Ready made firmy', to: { name: 'Ready made firmy' }, icon: LibraryIcon },
 ]
const userNavigation = [{ name: 'Profil', href: '/profile' }]

const sidebarOpen = ref(false)

const router = useRouter()

function logout() {
  store.dispatch('logoutUser').then(() => {
    router.push({
      name: 'Login',
    })
  })
}
</script>
